import { useDataSubmit, useDataValue } from 'Simple/Data'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let id = useDataValue({
    context: 'card',
    path: 'id',
    viewPath: props.viewPath,
  })

  let person = useDataValue({
    context: 'person',
    viewPath: props.viewPath,
  })

  return function onClick() {
    let action =
      person?.id === 'delete'
        ? { type: 'delete_task_assignee', task_id: id }
        : person
          ? {
              type: 'set_task_assignee',
              task_id: id,
              user_id: person.id,
              person,
            }
          : null

    if (!action) return

    submit(action)
    setFlowTo(normalizePath(props.viewPath, '../../../../No'))
  }
}
